import { Box, type BoxProps, Text } from '@doist/marketist';
import cn from 'clsx';
import css from './handwritten-box.module.css';
import type { CSSProperties, ReactNode } from 'react';
type HandwrittenBoxProps = BoxProps & {
  tilt?: number;
  arrow?: ReactNode;
  arrowPosition?: 'top' | 'right' | 'bottom' | 'left';
};
function HandwrittenBox({
  children,
  arrow,
  arrowPosition = 'right',
  tilt = 0,
  className,
  ...rest
}: HandwrittenBoxProps) {
  const customProps: CSSProperties = {
    '--text-tilt': `${tilt}deg`
  };
  return <Box className={cn(css.handwrittenBox, css[arrowPosition], className)} {...rest} style={customProps} data-sentry-element="Box" data-sentry-component="HandwrittenBox" data-sentry-source-file="handwritten-box.tsx">
            <Text size="handwritten-base" data-sentry-element="Text" data-sentry-source-file="handwritten-box.tsx">{children}</Text>
            <Box className={css.arrow} data-sentry-element="Box" data-sentry-source-file="handwritten-box.tsx">{arrow}</Box>
        </Box>;
}
export { HandwrittenBox };